import { useFocusEffect } from '@react-navigation/native';
import Paywall from 'app/components/paywall/paywall';
import { useNavigation, useNavigationOptions } from 'app/hooks/navigation';
import { Event, track } from 'app/lib/analytics';
import type { ScreenParameters } from 'app/types/navigation';
import React, { useCallback } from 'react';

export function PaywallScreen() {
  const navigation = useNavigation();

  useNavigationOptions(navigation, {
    headerShown: false,
  });

  useFocusEffect(
    // Keep the focus-effect identity stable so re-renders do not duplicate analytics events.
    useCallback(() => {
      const routeNames = navigation.getState().routes.map((route) => route.name);
      const source = routeNames[routeNames.length - 2] as keyof ScreenParameters | undefined;
      if (source) {
        track(Event.PaywallOpened, {
          source: source === 'new' ? 'new_need' : source,
        });
      }
      // Intentionally no cleanup: the atom is reset by the parent PaywallEffect
      // when the paywall route is no longer in the stack.
    }, [navigation]),
  );

  return <Paywall />;
}
